/** Platform help open — used by portal AI citations and in-app deep links. */

export const HELP_OPEN_EVENT = 'mboss:help-open';

/**
 * Open the Help drawer, optionally on a specific markdown doc.
 * @param {{ docPath?: string, slug?: string }} [detail]
 */
export function openHelpDoc(detail = {}) {
  const docPath = detail.docPath || slugToHelpDocPath(detail.slug);
  window.dispatchEvent(
    new CustomEvent(HELP_OPEN_EVENT, {
      detail: { ...detail, docPath: docPath || detail.docPath || null },
    })
  );
}

/**
 * Map Knowledge slug / id to help markdown path.
 * client-accounts → client/help/accounts.md
 */
export function slugToHelpDocPath(slugOrId) {
  if (!slugOrId) return null;
  let key = String(slugOrId).trim().toLowerCase();
  key = key.replace(/@v?\d+$/i, '');
  if (key.indexOf('help-') === 0) key = key.slice(5);
  const m = key.match(/^(admin|client|wifi|reseller)-(.+)$/);
  if (!m) return null;
  return `${m[1]}/help/${m[2]}.md`;
}

/**
 * Parse citation token like client-accounts@v2 or [client-accounts@v2]
 * @returns {{ slug: string, version: string|null }|null}
 */
export function parseKnowledgeCitation(token) {
  const raw = String(token || '')
    .trim()
    .replace(/^\[/, '')
    .replace(/\]$/, '');
  const m = raw.match(/^((?:help-)?(?:admin|client|wifi|reseller)-[a-z0-9-]+)(?:@v?(\d+))?$/i);
  if (!m) return null;
  return { slug: m[1].replace(/^help-/i, '').toLowerCase(), version: m[2] || null };
}
